import { render } from "./CxMainDataPanel.vue?vue&type=template&id=b3398324"
import script from "./CxMainDataPanel.vue?vue&type=script&lang=js"
export * from "./CxMainDataPanel.vue?vue&type=script&lang=js"

import "./CxMainDataPanel.vue?vue&type=style&index=0&id=b3398324&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__